import { motion } from 'framer-motion6';
import styled, { css } from 'styled-components';
import { H3 } from 'components/Typography';
import { ReactComponent as ChevronLeft } from 'assets/img/icons/chevron-left.svg';
import { th, variants } from 'style/theme';
import { sizes } from 'style';

export const Card = styled(motion.div)`
  border-radius: 16px;
  padding: 24px;
  box-shadow: ${th('shadows.smallShadow')};
  color: ${th('colors.pickledBluewood')};

  @media ${sizes.desktop} {
    padding: 32px;
    border-radius: 24px;
  }

  ${variants('variant', {
    light: css`
      background-color: ${th('colors.white')};
      color: ${th('colors.pickledBluewood')};
    `,
    dark: css`
      background-color: ${th('colors.pickledBluewood')};
      color: ${th('colors.white')};
    `
  })};

  ${({ isOpen }) => !isOpen && 'cursor: pointer;'}
`;

export const CustomCardTitle = styled(H3)`
  font-size: 20px;
  weight: 700;

  @media ${sizes.desktop} {
    font-size: 24px;
  }
`;

export const Explanation = styled.div`
  font-size: 14px;
  margin-bottom: 16px;

  @media ${sizes.desktop} {
    font-size: 16px;
  }
`;

export const StyledLink = styled.span`
  font-weight: bold;
  color: ${th('colors.tertiaryLink.default')};
  text-decoration: none;
  cursor: pointer;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 4px;
  align-items: center;
  font-size: 20px;
  font-weight: 700;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Button = styled.div`
  color: ${th('colors.fountainBlue')};
  font-size: 14px;
  font-weight: 500;
  border-bottom: 2px solid ${th('colors.fountainBlue')};
  transition: background-color 200ms, color 200ms;
  cursor: pointer;

  > svg {
    display: none;
    fill: ${th('colors.pickledBluewood')};
  }

  &:hover {
    background-color: ${th('colors.pickledBluewood4')};
  }

  @media ${sizes.desktop} {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border: 1.5px solid ${th('colors.pickledBluewood')};
    border-radius: 12px;
    padding: 8px 12px;
    background-color: ${th('colors.white')};
    color: ${th('colors.pickledBluewood')};

    > svg {
      display: inline;
    }
  }
`;

export const Text = styled.div`
  font-size: 14px;
  line-height: 20px;

  @media ${sizes.desktop} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Overview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${sizes.tabletLandscape} {
    flex-direction: row;
    gap: 24px;

    > :first-child {
      flex: 1;
    }

    > :last-child {
      flex: 2;
    }
  }

  @media ${sizes.desktop} {
    flex-direction: column;
  }

  @media ${sizes.largeDesktop} {
    flex-direction: row;
  }
`;

export const SummaryDescription = styled(Text)`
  margin-bottom: 24px;
`;

export const Chevron = styled(ChevronLeft)`
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(90deg);' : 'rotate(-90deg)')};
  fill: ${th('colors.white')};
  transition: transform 200ms;
  cursor: pointer;
`;
